/** @jsxRuntime classic */
/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import Link from "../../../shared/Link/Link";
import {
  primary_light,
  primary_darken_5,
  primary_lighten_10,
} from "../../../shared/lib/colors";

import "./Services.scss";

const Services = ({ services, primaryColor, uiVariantServices }) => {
  const serviceStyle = css`
    &.variant-1 .service {
      margin-bottom: 20px;
      padding: 20px 20px 15px;
      font-size: 18px;
      color: ${primaryColor};
      background-color: ${primary_light(primaryColor)};
      border-radius: 12px;

      &:hover {
        background-color: ${primary_darken_5(primary_light(primaryColor))};
      }

      @media (min-width: 992px) {
        margin-bottom: 0;
      }

      svg {
        margin: 0 30px 0 0;

        @media (min-width: 768px) {
          margin: 0 0 5px 0;
        }
      }
    }

    &.variant-2 .service {
      margin-bottom: 20px;
      padding: 20px 20px 15px;
      font-size: 18px;
      color: #ffff;
      background-color: ${primaryColor};

      @media (min-width: 992px) {
        margin-bottom: 0;
      }

      &:hover {
        background-color: ${primary_lighten_10(primaryColor)};
      }

      svg {
        margin: 0 30px 0 0;

        @media (min-width: 768px) {
          margin: 0 0 5px 0;
        }
      }
    }

    &.variant-3 .service {
      margin-bottom: 20px;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 15px 10px;
      font-size: 14px;
      color: ${primaryColor};
      background-color: #fff;

      @media (min-width: 992px) {
        margin-bottom: 0;
      }

      &:hover {
        background-color: ${primary_light(primaryColor)};
      }

      svg {
        margin: 0 30px 0 0;

        @media (min-width: 768px) {
          margin: 0 10px 0 0;
        }
      }

      .sub-title {
        color: #4f4f4f;
        text-transform: uppercase;
      }
    }
  `;

  return (
    <div className={`services variant-${uiVariantServices}`} css={serviceStyle}>
      <div className="title">Servizi</div>
      <div className="row boxes">
        {services.map((service) => {
          return (
            <div key={service.id} className="col-md-6 col-lg-3">
              <Link to={`#${service.url}`} className="service">
                {service.icon}
                <span className="sub-title">{service.title}</span>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Services;
